import React from 'react';
import { Link } from '../Link';
import { PopupLink } from '../../components/PopupLink';
import './SiteFooterLinks.scss';

export const HowToShop = () => (
  <div className="SiteFooterLinks">
    <Link to="/rewards" target="_blank">
      Moda Rewards
    </Link>
    <Link to="/editorial/moda-private" target="_blank">
      Moda Private
    </Link>
    <Link to="/editorial/our-locations" target="_blank">
      Moda Showrooms
    </Link>
  </div>
);

export const AboutModa = () => (
  <div className="SiteFooterLinks">
    <Link to="/about#careers" target="_blank">
      Careers
    </Link>
    <Link to="/editorial/about-us" target="_blank">
      About Us
    </Link>
    <Link to="/about#contact" target="_blank">
      Contact Us
    </Link>
    <Link to="/editorial/newsroom" target="_blank">
      Newsroom
    </Link>
  </div>
);

export const HelpCenter = () => (
  <div className="SiteFooterLinks">
    <PopupLink href="http://help.modaoperandi.com/hc/en-us/articles/210056706-Tracking-Your-Order">
      Track An Order
    </PopupLink>
    <PopupLink href="http://help.modaoperandi.com/hc/en-us/articles/211521863-Return-Policy">
      Return Policy
    </PopupLink>
    <PopupLink href="http://help.modaoperandi.com/hc/en-us/articles/210056806-Returning-Your-Order">
      Return An Order
    </PopupLink>
    <PopupLink href="http://help.modaoperandi.com/hc/en-us/articles/211521843-Shipping-Times-Costs">
      Shipping Times &amp; Costs
    </PopupLink>
    <PopupLink href="http://help.modaoperandi.com/hc/en-us">FAQs</PopupLink>
  </div>
);
